export default __webpack_public_path__ + "static/media/blog-paver-walkway-009.cc5edb50.jpg";